import { Button } from "@blueprintjs/core";

export const DeleteButton = ({ children, onClick }) => {
  return (
    <Button small minimal icon="trash" intent="danger" onClick={onClick}>
      {children}
    </Button>
  );
};
